import React from 'react';
import { toJS } from 'mobx';
import { observer } from 'mobx-react';
import UsageStatsStudentListDialog from './UsageStatsStudentListDialog';
import UsageStatsStudentListDialogService from '../services/UsageStatsStudentListDialogService'

const UsageStatsStudentListDialogContainer = () => (
  <UsageStatsStudentListDialog
    isOpen={UsageStatsStudentListDialogService.show}
    companyId={UsageStatsStudentListDialogService.companyId}
    students={toJS(UsageStatsStudentListDialogService.students)}
    onClose={UsageStatsStudentListDialogService.handleClose}
    values={UsageStatsStudentListDialogService.form.getValues()}
    onChange={UsageStatsStudentListDialogService.form.setValue}
    onFilter={UsageStatsStudentListDialogService.handleFilter}
  />
);

export default observer(UsageStatsStudentListDialogContainer);
